import { hasCapability, type User } from "../base";

export const user = {
  code: (user: User) => hasCapability(user, "user.code"),
  design: (user: User) => hasCapability(user, "user.design"),
  create: (user: User) => hasCapability(user, "user.create"),
  updateStatus: (user: User) => hasCapability(user, "user.updateStatus"),
};
